module.exports = __webpack_public_path__ + "pc/static/img/user.9208377a.png";